// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oa-1";
export var stateContainer = "_oa-0";